// KLUB-185 — a identidade jurídica do clube, declarada uma vez.
//
// Seis campos de `tenants` que a equipe Klubora cadastra no platform e que
// governam dois desfechos: a fatura B2B (razão social, CNPJ, email de cobrança)
// e a publicação dos textos legais (sede, foro, encarregado). As duas edge
// functions do platform recusam a escrita enquanto o conjunto estiver
// incompleto — e a tela precisa contar os mesmos campos que o servidor, ou
// diria "completo" sobre um cadastro que o save vai recusar.
//
// O ESPELHO EM DENO. Edge function não alcança `@klubora/shared` (o bundle do
// deploy não passa pelo build npm), então `supabase/functions/_shared/tenant-
// identity-completeness.ts` repete esta lista. O custo do espelho é a deriva, e
// a deriva é o que `tests/shared/tenant-identity-completeness.test.ts` guarda:
// ele compara as duas listas campo a campo, na ordem.

export type TenantIdentityColumn =
  | "legal_name"
  | "legal_cnpj"
  | "legal_address"
  | "legal_jurisdiction"
  | "privacy_contact"
  | "billing_email";

export interface TenantIdentityField {
  column: TenantIdentityColumn;
  /** O nome que o operador reconhece na tela — é isto que a recusa imprime. */
  label: string;
}

/** Na ordem em que a ficha do platform apresenta os campos. */
export const TENANT_IDENTITY_FIELDS: ReadonlyArray<TenantIdentityField> = [
  { column: "legal_name", label: "razão social" },
  { column: "legal_cnpj", label: "CNPJ" },
  { column: "legal_address", label: "endereço da sede" },
  { column: "legal_jurisdiction", label: "comarca do foro" },
  { column: "privacy_contact", label: "contato do encarregado de dados" },
  { column: "billing_email", label: "email de cobrança" },
];

export const TENANT_IDENTITY_COLUMNS: ReadonlyArray<TenantIdentityColumn> =
  TENANT_IDENTITY_FIELDS.map((f) => f.column);

/** Código de erro que as duas edge functions devolvem, e que a tela traduz. */
export const IDENTITY_INCOMPLETE = "identity_incomplete";

/**
 * Os rótulos que faltam num estado — TODOS, na ordem da tela.
 *
 * O parâmetro é `unknown` de propósito: os chamadores são a linha do banco
 * (valores `string | null`), o formulário do wizard e o do modal (interfaces
 * fechadas, sem índice de string). Estreitar aqui dentro evita espalhar
 * `as Record<string, unknown>` por cada chamada — e um cast por chamada é o
 * tipo de ruído que esconde o argumento errado.
 */
export function missingTenantIdentityFields(state: unknown): string[] {
  const row = typeof state === "object" && state !== null
    ? state as Record<string, unknown>
    : null;
  return TENANT_IDENTITY_FIELDS
    .filter((f) => {
      const value = row?.[f.column];
      return typeof value !== "string" || value.trim() === "";
    })
    .map((f) => f.label);
}
